import React, { useMemo, useRef } from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { UIGameResourceCardsTooltipContent } from '../../../common/UIGameResourceCardsTooltipContent/index.ts';
import { getCardsForPiece } from '@colonist/game-card-types';
import { PieceTypes } from '@colonist/game-base-types';
import { useActionButtonCommonErrors } from '../utils.ts';
import { SHIP_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { ActionState } from '@colonist/game-states';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { useMechanicValidatorShip } from '../../../store/selectors/useMechanicValidatorShip.ts';
const cardsToBuildShip = getCardsForPiece(PieceTypes.Ship);
export const UIGameActionButtonShip = ({ className })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const currentStateValidator = useCurrentStateValidator();
    const { getPlayerValidator } = usePlayerValidators();
    const { sendBuildShip, sendCancelAction, sendClearRoadEdgeHighlight } = useGameStore((state)=>state.gameSendEvent);
    const playerValidator = getPlayerValidator(myColor);
    const { errorHelperText, hasCommonErrors } = useActionButtonCommonErrors();
    const tooltipRef = useRef(null);
    const shipValidator = useMechanicValidatorShip();
    const actionStatus = useMemo(()=>{
        if (!shipValidator) {
            return {
                canTakeAction: false
            };
        }
        const useResources = true;
        const canPlaceShipActionStatus = shipValidator.canPlayerPlaceShip(myColor, useResources);
        return canPlaceShipActionStatus;
    }, [
        shipValidator,
        myColor
    ]);
    const triggerFlickerCardsAnimation = ()=>{
        const notEnoughResources = !playerValidator.hasResourceCardsInHand(cardsToBuildShip);
        if (notEnoughResources) {
            var _tooltipRef_current;
            (_tooltipRef_current = tooltipRef.current) === null || _tooltipRef_current === void 0 ? void 0 : _tooltipRef_current.triggerFlickerAnimation();
        }
    };
    const disabled = hasCommonErrors || !actionStatus.canTakeAction;
    const actionState = currentStateValidator.getPlayerActionState(myColor);
    const isPlacingShip = actionState === ActionState.PlaceShip && !disabled;
    var _shipValidator_getShipPlayerState_bankShipAmount;
    const bankShipAmount = (_shipValidator_getShipPlayerState_bankShipAmount = shipValidator === null || shipValidator === void 0 ? void 0 : shipValidator.getShipPlayerState(myColor).bankShipAmount) !== null && _shipValidator_getShipPlayerState_bankShipAmount !== void 0 ? _shipValidator_getShipPlayerState_bankShipAmount : 0;
    const icon = SHIP_IMAGE_PATH[myColor];
    const helperText = errorHelperText || actionStatus.errorMessageIfCantTakeAction;
    const onClick = ()=>{
        if (disabled) return;
        if (isPlacingShip) {
            sendClearRoadEdgeHighlight();
            sendCancelAction();
        } else {
            sendBuildShip();
        }
    };
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        count: bankShipAmount,
        countColor: myColor,
        disabled: disabled,
        helperText: helperText,
        highlight: isPlacingShip,
        iconPath: icon,
        onClick: onClick,
        onClickActionIfDisabled: triggerFlickerCardsAnimation,
        tooltipCustomMenuComponent: /*#__PURE__*/ React.createElement(UIGameResourceCardsTooltipContent, {
            cardInventory: playerValidator.resourceCards.cards,
            cardsToBuild: cardsToBuildShip,
            ref: tooltipRef
        })
    });
};
